<script lang="ts" setup>
import { computed } from 'vue';
import '../scss/Steps.scss';
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n();
const steps = computed(() => {
  locale.value;

  return [
  	t('landing.components.steps.cotiza'),
	t('landing.components.steps.completa_detalle_viaje'),
	t('landing.components.steps.solicita_cobertura'),
	t('landing.components.steps.haz_pago_online'),
	t('landing.components.steps.obten_poliza'),
  ];
});
</script>

<template>
  <div class="steps">
    <h3 class="steps__title">{{ t('landing.components.steps.obtener_un_seguro') }}</h3>
    <div class="steps__container">
      <div
        :class="{
          steps__box: true,
          'steps__box--light': index % 2 === 0,
          'steps__box--hide-arrow': index === steps.length - 1,
        }"
        v-for="(step, index) in steps"
        :key="step"
      >
        <div class="steps__number">{{ index + 1 }}</div>
        <div class="steps__description">{{ step }}</div>
        <div class="steps__arrow-container">
          <img src="/img/arrow.png" class="steps__arrow-img" />
        </div>
      </div>
    </div>
  </div>
</template>
